import React from "react";
import { ContainerHD } from "./style.css";
import laTercera from "../../images/la tercera.png";
import labcon from "../../images/Lab.png";
import title from "../../images/logo-eternos-campeones.svg";
import adidas from "../../images/logo-adidas.svg";

const Header = () => {
  return (
    <ContainerHD>
      <div className="item1">
        <a
          href="https://latercera.com/?utm=source=header&utm_medium=yolovivi"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={laTercera} alt="La Tercera logo" />
        </a>
      </div>
      <div className="item3">
        <a
          href="https://eternoscampeones.cl/?utm=source=header&utm_medium=yolovivi"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={title} alt="Eternos Campeones" />
        </a>
        <span className="sponsor">
          <span>Presentado por:</span>
          <img src={adidas} alt="Adidas" />
        </span>
      </div>
      <div className="item4">
        <a
          href="https://laboratoriodecontenidos.cl/?utm=source=header&utm_medium=yolovivi"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={labcon} alt="Laboratorio de Contenidos de Marca" />
        </a>
      </div>
    </ContainerHD>
  );
};

export default Header;
